<template>
  <div>
    <main class="main reception">
      <div class="section top">
        <div class="top__headline">
          <h2>적격여부를 확인해주세요!</h2>
        </div>
      </div>
      <div class="section call-guidance">
        <div class="call-guidance--rectangle">
          <div class="paragraph">
            <ul>
              <li>
                결격여부 확인을 위한 조회는 신용평점에 영향을 주지 않습니다.
              </li>
              <li>
                신용평점 390점 미만 및 현재 연체가 있을 시 대출이 제한됩니다.
              </li>
              <li>
               1종 유흥 외 특수업종에 한하여 진행에 제한이 있을 수 있습니다.
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="section bottom">
        <button
          v-ripple
          class="button next-button"
          :disabled="isInProgress"
          type="button"
          @click="insertEvaluation()"
        >
          적격 여부 확인하기
          <v-progress-circular
            style="padding-left: 15px"
            size="24"
            v-if="isInProgress"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </button>
      </div>
    </main>
  </div>
</template>
<script>
import CreditEvaluationsService from '@/service/creditEvaluations/CreditEvaluationsService'

import { mapActions } from 'vuex'

export default {
  created() {
    this.$store.commit('ui/headerTitle', '정보 등록하기')
  },
  data() {
    return {
      isInProgress: false,
      url: null,
    }
  },
  methods: {
    ...mapActions('loading', {
      setIsLoading: 'setIsLoading'
    }),
    async insertEvaluation() {
      if (this.isInProgress === true) {
        return
      }
      this.isInProgress = true

      try {
        let { data } = await CreditEvaluationsService.postCreditEvaluations()
        this.setIsLoading(true)
        let returnUrl =
          location.origin + '/factoring/evaluation?evid=' + data.uuid
        let url = data.kcb_url + '&RTN_URL=' + encodeURI(returnUrl)
        if (navigator.userAgent.match(/Android/i)) {
          document.location.replace(url)
        } else {
          location.href = url
        }
      } catch (e) {
        console.error(e)
        this.isInProgress = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
button[disabled] {
  color: lightgrey;
}

ul {
  margin-top: 24px;
  font-size: 14px;
  line-height: 1.56;
  color: #727d8c;
  padding-left: 1em;
  li {
    margin-top: 6px;
  }
}
</style>
